import { ChangePasswordModel } from './../../../models/Auth/ChangePasswordModel';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { OnlineAccountValidation } from 'src/app/models/enums/Auth/OnlineAccountValidationEnum';
import { FormGroup, FormControl, Validators, FormBuilder }  from '@angular/forms';
import { ChangeEmailModel } from './../../../models/Auth/ChangeEmailModel';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit {


  faTimesCircle = faTimesCircle;
  userEmail: string;
  form: FormGroup;
  submitted = false;
  user:any;
  customer:any;
  afterChangeLink;
  emailOldVal = '';
  err;
  EmailPattern = '^(?=.*[0-9])(?=.*[!@#$%^&*])[0-9a-zA-Z!@#$%^&*0-9]{8,}$';


  constructor(

    private authService: AuthService,
    private dialogRef: MatDialogRef<ChangeEmailComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private router: Router,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    ) {

  }


  get f() { return this.form.controls; }

  ngOnInit() {
    this.authService.loggedInUser.subscribe(res =>{
      if(res != null){
        this.user=res;
        this.customer=res.customerModel;
      }
    })
    this.form = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, , Validators.pattern(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)])],
    });
  }


  onSubmit() {
      this.submitted = true;
      if (this.form.invalid) {
          return;
      }
      //alert(JSON.stringify(this.form.value));
     // this.user = JSON.parse(this.authService.GetUserStorage());
      //this.customer = JSON.parse(this.authService.GetCustomerStorage());
      this.afterChangeLink = "/";

      let req: ChangeEmailModel = {
        email: this.form.value["email"],
        customerID: this.customer.customerID,
        userId: this.user.id,
        redirectBaseUrl: this.afterChangeLink,
      }

      this.authService.changeEmail(req).subscribe(res => {

        this.submitted = false;
        this.dialogRef.close({success:true});
        }, err => {
          const validationCode = err.error.code;
          switch (validationCode) {
            case OnlineAccountValidation.UserAlreadyExist: //User not exist
              this.form.controls['email']?.setErrors({ 'UserAlreadyExist': 'UserAlreadyExist' });
              break;
          }
        });
  }


  close() {
    this.submitted = false;
    this.dialogRef.close();
  }


  // emilBlur(event) {

  //   let val = event.target.value;
  //   if (val != null && val != "") {
  //     val = (val as string).trim();
  //     let errors = this.form.controls['email'].errors;
  //     if (errors == null) {

  //       this.emailOldVal = val;
  //       this.auth.checkIfEmailExist(val).subscribe(res => {
  //         if (res) {
  //           this.translate.get('EmailAlreadyExist').subscribe(res => {
  //            ;
  //             this.form.controls['email']?.setErrors({ 'exist': res });
  //             this.submitted = false;
  //           })
  //         }
  //         else {
  //           this.form.controls['email']?.setErrors(null);
  //         }
  //       })

  //     }
  //   }

  // }


}
